import { ERROR, LOADING, SUCCESS, SUCCESS_DETAILED_PERCENTILES } from './CTSPActions';

const INITIAL_STATE = {
  isLoading: true,
  success: false,
  error: '',
  data: [],
  percentileTrends: [],
  percentileDetails: {
    system: [],
    lists: [],
  },
};

const CTSPReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.data,
        percentileTrends: action.percentileTrends,
      };
    }
    case SUCCESS_DETAILED_PERCENTILES: {
      return { ...state, percentileDetails: action.data };
    }
    default:
      return state;
  }
};

export default CTSPReducer;
